<app-select [required]="required" [optionsProvider]="getProviders()" [(ngModel)]="value" dataKey="code"
            [formatter]="providerFormatter" [addSelectedIfNotExists]="true" (ngModelChange)="onProviderChange($event)"
            [disabled]="disabled"></app-select>